"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayoutMainSize = void 0;
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// eslint-disable-next-line @typescript-eslint/no-empty-interface
let AppLayoutMainSize = exports.AppLayoutMainSize = /*#__PURE__*/function (AppLayoutMainSize) {
  AppLayoutMainSize["Large"] = "large";
  AppLayoutMainSize["Medium"] = "medium";
  return AppLayoutMainSize;
}({});